const getRemovalSource = (source) => {
    if (!source) return "removed.";
    switch (source) {
        case "deleted":
            return "deleted by the user.";
        case "politicsFilter":
            return "removed by politics filter in non-political community.";
        case "politicsFilterPending":
            return "removed by politics filter in non-political community, pending further review.";
        case "spamFilter":
            return "removed by spam filter.";
        case "spamFilterPending":
            return "removed by spam filter, pending further review.";
        case "communityFilter":
            return "removed by community filter.";
        case "communityFilterPending":
            return "removed by community filter, pending further review.";
        case "contentPolicy":
            return "removed for violating our Content Policy.";
        case "contentPolicyPending":
            return "removed for violating our Content Policy, pending further review.";
        case "nuke":
            return "removed upon the user being banned.";
        case "nukePending":
            return "removed upon the user being banned, pending further review.";
        case "moderator":
            return "removed by community moderators.";
        case "moderatorPending":
            return "removed by community moderators, pending further review.";
        case "riskFilter":
            return "removed by community moderators.";
        case "riskFilterPending":
            return "removed by community moderators, pending further review.";
        default:
            return "removed.";
    }
}

export default getRemovalSource;
